import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is defined in your config

const EditItemWeighments = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [item, setItem] = useState('');
    const [barcode, setBarcode] = useState('');
    const [weight, setWeight] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Fetch the existing data for the item weighment
        setLoading(true);
        fetch(`${BASE_URL}itemweighments/${id}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    const { item, barcode, weight } = data.data;
                    setItem(item);
                    setBarcode(barcode);
                    setWeight(weight);
                } else {
                    setError('Failed to fetch item weighment data');
                }
            })
            .catch((err) => {
                console.error('Error fetching item weighment:', err);
                setError('An error occurred while fetching the item weighment');
            })
            .finally(() => setLoading(false));
    }, [id]);

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!item || !barcode || !weight) {
            setError('Please fill out all fields');
            return;
        }

        const requestData = {
            item,
            barcode,
            weight: parseFloat(weight),
        };

        fetch(`${BASE_URL}itemweighments/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    navigate('/ItemWeighmentsList'); // Navigate to the list page after successful update
                } else {
                    setError('Failed to update item weighment');
                }
            })
            .catch((err) => {
                console.error('Error updating item weighment:', err);
                setError('An error occurred while updating the item weighment');
            });
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Item Weighment</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Edit Item Weighment Details</h4>
                            </div>
                            <div className="card-body">
                                {error && <div className="alert alert-danger">{error}</div>}
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <label htmlFor="item">Item Name</label>
                                        <input
                                            type="text"
                                            id="item"
                                            className="form-control"
                                            placeholder="Enter item name"
                                            value={item}
                                            onChange={(e) => setItem(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="barcode">Barcode</label>
                                        <input
                                            type="text"
                                            id="barcode"
                                            className="form-control"
                                            placeholder="Enter barcode"
                                            value={barcode}
                                            onChange={(e) => setBarcode(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="weight">Weight</label>
                                        <input
                                            type="number"
                                            step="0.01"
                                            id="weight"
                                            className="form-control"
                                            placeholder="Enter weight"
                                            value={weight}
                                            onChange={(e) => setWeight(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group mt-3">
                                        <button type="submit" className="btn btn-primary">Update Item Weighment</button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary ms-2"
                                            onClick={() => navigate('/ItemWeighmentsList')}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditItemWeighments;
